import {CssBaseline} from "@mui/material";
import {ThemeProvider} from "@mui/material/styles";
import { ThemeProvider as ThemeProviderSC } from "styled-components";
import App from "next/app";
import * as React from "react";
import { useStore } from "react-redux";

import { PersistGate } from "redux-persist/integration/react";
import { wrapper } from "../src/store";
import { GlobalStyles } from "../styles/GlobalStyles";
import { theme } from "../styles/styles";
import 'react-datepicker/dist/react-datepicker.css';
import {Suspense} from "react";


function MyApp({ Component, pageProps }) {
  // This is for redux
  /* static async getInitialProps({ Component, ctx }) {
     if (ctx.isServer) {
       // Runs once per connection only on the server. Good place to get initial state for the site
       // ctx.store.dispatch({ type: 'FOO', payload: 'foo' });
     }
     const pageProps = Component.getInitialProps
       ? await Component.getInitialProps(ctx)
       : {};

     return { pageProps };
   }*/

  const canUseDom = !!(
    typeof window !== "undefined" &&
    window.document &&
    window.document.createElement
  );

  const store = useStore();

  if (!canUseDom)
    return (
        <div>Loading</div>
    );

  return (
        <PersistGate
            persistor={(store as any).__persistor}
            loading={<div>Loading</div>}
        >
          <ThemeProvider theme={theme}>
            <ThemeProviderSC theme={theme}>
              <CssBaseline />
              <GlobalStyles />
              <Component {...pageProps} />
            </ThemeProviderSC>
          </ThemeProvider>
        </PersistGate>
  );
}

export default wrapper.withRedux(MyApp);
